import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Login from './Login';
import App from "./App.js";
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ensureMessagingToken, attachForegroundMessageListener } from './firebaseMessaging';
import { save_push_notification_token } from './utils/talent_services';
import 'bootstrap/dist/css/bootstrap.min.css';
import Temp_sergio from './Temp_sergio.js';
import SetPWD from './SetPWD.js';
import WorkshopsCertificates from './components/pages/workshops/WorkshopsCertificates.js';
import WorkshopsCertificateLookup from './components/pages/workshops/WorkshopsCertificateLookup.js';

const router = createBrowserRouter([{
  path: "/",
  element:<Login/>
},
{
  path: "/Dashboard",
  element:<App page={"Dashboard"}/>
},
{
  path: "/project",
  element:<App page={"Project_admin"}/>
},
{
  path: "/Projects_relations",
  element:<App page={"Projects_relations"}/>
}
,
{
  path: "/Despachos",
  element:<App page={"Despachos"}/>
}
,
{
  path: "/Units_status",
  element:<App page={"Units_status"}/>
},
{
  path: "/casos",
  element:<App page={"Casos"}/>
},
{
  path: "/helpdesk",
  element:<App page={"Email_info"}/>
},
{
  path: "/helpdesk_report",
  element:<App page={"Cases_report"}/>
},
{
  path: "/members_master",
  element:<App page={"Members_master"}/>
},
{
  path: "/Versions",
  element:<App page={"TOMi8versions"}/>
},
{
  path: "/Models",
  element:<App page={"Models_Admin"}/>
},
{
  path: "/Legacy",
  element:<App page={"Legacy"}/>
},
{
  path: "/expenses",
  element:<App page={"Expenses"}/>
},
{
  path: "/stocks",
  element:<App page={"Stocks"}/>
},

{
  path: "/awards",
  element:<App page={"Awards"}/>
},
{
  path: "/strategypage",
  element:<App page={"Strategypage"}/>
},
{
  path: "/strategylist",
  element:<App page={"Strategylist"}/>
},

{
  path: "/individual_stock",
  element:<App page={"Individual_stock"}/>
},
{
  path: "/Premium_services",
  element:<App page={"Premium_services"}/>
},
{
  path: "/Contractor",
  element:<App page={"Contractor"}/>
},
{
  path: "/channels",
  element:<App page={"Channels"}/>
},
{
  path: "/opportunities",
  element:<App page={"Opportunities"}/>
},
{
  path: "/channel_panel",
  element:<App page={"Channel_panel"}/>
},
{
  path: "/qrshorter",
  element:<App page={"Qrshorter"}/>
},
{
  path: "/opportunitypage",
  element:<App page={"OpportunityPage"}/>
},
{
  path: "/transactions",
  element:<App page={"Transactions"}/>
},
{
  path: "/set_password",
  element:<SetPWD />
},
{
  path: "/tactic_followup",
  element:<App page={"Tacticfollowup"}/>

},

{
  path: "/task_progress",
  element:<App page={"Task_progress"}/>

},
{
  path: "/statistics",
  element:<App page={"Statistics"}/>

}
,
{
  path: "/nano_preview",
  element:<Temp_sergio />

},
{
  path: "/pins/lotes",
  element:<App page={"PinsLotes"}/>
},
{
  path: "/pins/generar",
  element:<App page={"PinsGenerar"}/>
},
{
  path: "/pins/validar",
  element:<App page={"PinsValidar"}/>
},
{
  path: "/pins/estado",
  element:<App page={"PinsEstado"}/>
}
,
{
  path: "/pins/qa/lotes",
  element:<App page={"PinsLotesQA"}/>
},
{
  path: "/pins/qa/estado",
  element:<App page={"PinsEstadoQA"}/>
},
{
  path: "/pins/cupones",
  element:<App page={"PinesCupones"}/>
},
{
  path: "/pins/qa/cupones",
  element:<App page={"PinesCuponesQA"}/>
},
{
  path: "/workshops/editor",
  element:<App page={"WorkshopsEditor"}/>
},
{
  path: "/workshops/certificates",
  element:<App page={"WorkshopsCertificates"}/>
}
,
{
  path: "/workshops/certificates-direct",
  element:<WorkshopsCertificates/>
}
,
{
  path: "/workshops/certificate",
  element:<WorkshopsCertificateLookup/>
},
{
  path: "/MassMessaging",
  element:<App page={"MassMessaging"}/>
},
{
  path: "/tomi8-api",
  element: <App page={"TOMi8Api"} />
},
{
  path: "/Admin_panel",
  element: <App page={"Admin_panel"} />
},
{
  path: "/Admin_products",
  element: <App page={"Admin_products"} />
}

]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId='1091848897000-sd4be2q49s01dbnfk7ugh9up3guev4ee.apps.googleusercontent.com'>
    <RouterProvider router={router}/>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (typeof window !== 'undefined') {
  ensureMessagingToken()
    .then((messagingToken) => {
      if (!messagingToken) {
        return null;
      }

      const sessionToken = localStorage.getItem('token');
      if (!sessionToken) {
        return null;
      }

      const userAgent = navigator.userAgent || '';
      let deviceType = 'web';
      if (/android/i.test(userAgent)) {
        deviceType = 'android';
      } else if (/iphone|ipad|ipod/i.test(userAgent)) {
        deviceType = 'ios';
      }

      return save_push_notification_token(sessionToken, messagingToken, deviceType);
    })
    .then((response) => {
      if (!response || response === 'INVALID') {
        // eslint-disable-next-line no-console
        console.warn('[Firebase] No se pudo registrar el token de notificaciones.');
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('[Firebase] Error al registrar el token de notificaciones:', error);
    });

  attachForegroundMessageListener((payload) => {
    const { notification } = payload;
    const data = { ...(payload.data ?? {}) };

    if (!data.click_action) {
      if (data.target_screen === 'task_progress' && data.task_id) {
        data.click_action = `/task_progress?task_id=${encodeURIComponent(data.task_id)}`;
      } else {
        data.click_action = '/';
      }
    }

    if (notification && Notification.permission === 'granted') {
      const { title, body, icon } = notification;
      const browserNotification = new Notification(title ?? 'Mensaje recibido', {
        body,
        icon: icon ?? '/logo192.png',
        data
      });

      browserNotification.onclick = (event) => {
        event.preventDefault();
        const destination = browserNotification.data?.click_action ?? '/';
        window.focus();
        window.location.assign(destination);
        browserNotification.close();
      };
    } else {
      // eslint-disable-next-line no-console
      console.info('[Firebase] Mensaje recibido en primer plano:', payload);
      if (data.click_action) {
        window.location.assign(data.click_action);
      }
    }
  });
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // El service worker unificado (PWA + Firebase) se publica como '/service-worker.js'.
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registrado con éxito. Alcance:', registration.scope);
      })
      .catch((error) => {
        console.error('Fallo en el registro del Service Worker:', error);
      });
  });
}
